import { RealtimeRole } from '@doxyme/realtime';
import { getApolloSessionDetails } from '../../../features/apolloSession/apolloSession.selectors';
import { useAppSelector } from '../../useReduxToolkit';
import { redirect } from '../../../shared/callUtils';

export const useRedirectAfterCallError = (): (() => Promise<void>) => {
  const apolloSession = useAppSelector(getApolloSessionDetails);
  const { role, referrer } = apolloSession;
  const isProvider = role === RealtimeRole.Provider;

  const redirectAfterCallError = async (): Promise<void> => {
    if (!isProvider) {
      redirect(referrer, false);
    }
  };

  return redirectAfterCallError;
};
